import { resolveV3 } from '@/endpoints/resolveV3';
import { LimitPaginatedResponse } from '@/models/endpoint';

import { State } from './getState';

export const statesToFilter = ['AK', 'HI'];

export type StateQueryData = {
  location?: {
    lat: number;
    lon: number;
  };
  params?: {
    limit?: number;
    offset?: number;
    /** True will include the geomtry of the state in the response */
    include__geometry: boolean;
    name__icontains?: string;
    /**
     * - state_fips - State FIPS
     * - -state_fips - State FIPS (descending)
     * - name - State name
     * - -name - State name (descending)
     * - state_abbrev - 2 letter state postal abbrevation
     * - -state_abbrev - 2 letter state postal abbrevation (descending)
     */
    ordering?: string;
  };
};

export async function getStates(
  params: StateQueryData,
  signal?: AbortSignal
): Promise<LimitPaginatedResponse<State>> {
  const queryParams = new URLSearchParams(
    params.params as unknown as Record<string, string>
  );
  if (params.location) {
    queryParams.append(
      'geometry__contains',
      `POINT (${params.location.lon} ${params.location.lat})`.toString()
    );
  }

  return resolveV3(
    {
      method: 'GET',
      params: queryParams,
      signal,
      url: `/states/`,
    },
    {
      baseUrl: 'itasca',
    }
  );
}
